import { type Chain } from 'viem'

const defaultSettings = {
  chainName: 'Arbitrum One',
  currencyDecimals: '18',
  currencyName: 'Ethers',
  currencySymbol: 'ETH',
  explorerName: 'Arbiscan',
  explorerUrl: 'https://arbiscan.io',
}

const rpcUrl = import.meta.env.VITE_RPC_URL
const explorerUrl = import.meta.env.VITE_EXPLORER_URL || defaultSettings.explorerUrl
const explorerName = import.meta.env.VITE_EXPLORER_NAME || defaultSettings.explorerName
const chainName = import.meta.env.VITE_CHAIN_NAME || defaultSettings.chainName
const currencyDecimals = import.meta.env.VITE_CHAIN_CURRENCY_DECIMALS || defaultSettings.currencyDecimals
const currencyName = import.meta.env.VITE_CHAIN_CURRENCY_NAME || defaultSettings.currencyName
const currencySymbol = import.meta.env.VITE_CHAIN_CURRENCY_SYMBOL || defaultSettings.currencySymbol

export const getUfarmChain = (chainId: number) =>
  ({
    blockExplorers: {
      default: { name: explorerName, url: explorerUrl },
    },
    id: chainId,
    name: chainName,
    nativeCurrency: {
      decimals: Number(currencyDecimals),
      name: currencyName,
      symbol: currencySymbol,
    },
    rpcUrls: {
      default: { http: [rpcUrl] },
      public: { http: [rpcUrl] },
    },
    testnet: true,
  }) as const satisfies Chain
